















































import { Prop, Component, Vue } from "vue-property-decorator";
import _ from "lodash";

import Chart from "@/models/chart";
import ChartRow from "@/models/chart-row";
import ChartBar from "@/models/chart-bar";
import VChartMask from "./VChartMask.vue";
import VChartRow from "./VChartRow.vue";
import VChartBar from "./VChartBar.vue";
import VGridMask from "../VGridMask.vue";
import { GridMask } from "@/viewmodels/grid-mask";

@Component({
  components: {
    VGridMask,
    VChartRow,
    VChartBar,
    VChartMask
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
})
export default class VChartBody extends Vue {
  @Prop({ required: true }) chart!: Chart;
  @Prop({ required: true }) chartMask!: GridMask;
  @Prop({ default: () => [] }) rows!: ChartRow[];
  @Prop({ default: false }) readonly!: boolean;

  select(bar: ChartBar, e: MouseEvent) {
    this.$emit("select", bar, e);
  }

  movestart(bar: ChartBar, e: MouseEvent) {
    this.setChange(e.pageX, cols => ({
      ...bar,
      start: bar.start + cols
    }));
  }

  shrinkstart(bar: ChartBar, e: MouseEvent) {
    this.setChange(e.pageX, cols => ({
      ...bar,
      start: bar.start + cols,
      span: Math.max(bar.span - cols, 1)
    }));
  }

  expandstart(bar: ChartBar, e: MouseEvent) {
    this.setChange(e.pageX, cols => ({
      ...bar,
      start: bar.span + cols > 0 ? bar.start : bar.start + (bar.span + cols),
      span: Math.max(bar.span + cols, 1)
    }));
  }

  handleChange = _.throttle(this.change, 50);

  change(e: MouseEvent) {
    this.doChange(e.pageX);
  }

  submit() {
    if (!this.changing) return;
    this.resetChange();
    this.$emit("submit");
  }

  cancel() {
    if (!this.changing) return;
    this.resetChange();
    this.$emit("cancel");
  }

  clickRow(e: MouseEvent, rowIndex: number) {
    if (this.changing) return;
    const colIndex = this.clickedColIndex(e, e.offsetX);
    this.$emit("click", rowIndex, colIndex);
  }

  sort(rows: ChartRow[]) {
    this.$emit("sort", rows);
  }

  /**
   * ポインターの位置から列を求める
   */
  private clickedColIndex(e: MouseEvent, x: number): number {
    return Math.floor(x / this.chart.colWidth);
  }

  private doChange: (x1: number) => void = () => {};
  private changing = false;
  private noClick = false;

  private setChange(x0: number, newBar: (cols: number) => ChartBar): void {
    this.changing = true;
    this.noClick = true;
    this.doChange = (x1: number) => {
      const dx = x1 - x0;
      const cols = Math.round(dx / this.chart.colWidth);
      this.$emit("change", newBar(cols));
    };
  }

  private resetChange() {
    this.doChange = () => {};
    this.changing = false;
  }
}
